import { useContext, type FC } from 'react';
import type { VolatilitySurfaceProps } from './types';
import { Widget } from '../../widget';
import TokenSelector from '../../token-selector';
import Source from '../../source';
import WidgetButtons from '../../widget-buttons';
import VolatilitySurfaceContent from './volatility-surface-content';
import { SnapshotContext } from '../../../../providers/snapshot-provider';

const VolatilitySurfaceWidget: FC<VolatilitySurfaceProps> = (props) => {
  const {
    widget,
    actions,
    permissions = { canChangeToken: true, canDelete: true, canDuplicate: true },
  } = props;
  const { token, setToken } = useContext(SnapshotContext);

  return (
    <Widget cardKey={widget.key}>
      <Widget.Header>
        <Widget.Title title={widget.title} />
        <Widget.HeaderPanel>
          <TokenSelector
            token={token}
            setToken={setToken}
            isFixedToken={!permissions.canChangeToken}
          />
        </Widget.HeaderPanel>
        <Widget.Buttons>
          <WidgetButtons widget={widget} actions={actions} permissions={permissions} />
        </Widget.Buttons>
      </Widget.Header>
      <Widget.Content>
        <VolatilitySurfaceContent
          providerKey={props.providerKey}
          isCustomWidget={props.isCustomWidget || false}
        />
      </Widget.Content>
      <Widget.Footer>
        <Source source="Deribit" url="https://www.deribit.com" />
      </Widget.Footer>
    </Widget>
  );
};

export default VolatilitySurfaceWidget;
